import { getApi } from './api';

const URL = '/auth';

const getLocalRoles = async () => {
  const api = await getApi({ ignoreCustomer: true });
  return api.get<string[]>(`${URL}/local-roles`).then((response) => response.data || []);
};

export const authService = {
  getLocalRoles,
};
